export default __webpack_public_path__ + "static/media/male_bone-01.a5589301.png";